import { useEffect, useMemo, useState } from 'react';
import { fetchResults } from "../../../helpers/utils";
import SqlApi from '../../../api/instance/SqlApi';
import { showError } from '../../../utils/showAlert';
import { useParams } from "react-router-dom";
import { useReturnTo } from "../../../hooks/useReturnTo";
import api from "../../../api/Base";
import NoData from "../../../component/NoData";
import SearchInput from "../../../component/SearchInput";
import { DATA_LOADED, DATA_LOADING } from "../../../component/Constants";

const Details = () => {
    const [sqlExtendedOptionsList, setSqlExtendedOptionsList] = useState<any[][]>([]);
    const [detailFilter, setDetailFilter] = useState<string>('');
    const [loading, setLoading] = useState<number>(DATA_LOADING);
    const returnFromForm = useReturnTo('/admin/database-extended-statistics');
    const { instanceId } = useParams();

    useEffect(() => {
        const getCollectStatisticsList = async() => {
            try {
                const results: any[][] = await fetchResults(
                    [SqlApi.fetchTypesByInstance(instanceId!)]);
                setLoading(DATA_LOADED);
                return results[0]
            } catch (error: any) {
                console.error(error);
                const errorMessage = error.message || error.toString();
                showError('Failed to load SQL statistics details', errorMessage);
                setLoading(DATA_LOADED);
                return [];
            }
        }

        getCollectStatisticsList().then(setSqlExtendedOptionsList)
    }, []);

    const updateSqlExtendedOptionsList = (value: string, type: string) => {
        const list = JSON.parse(JSON.stringify(sqlExtendedOptionsList))
        const findIemToChange = list.find((item: {
            statistic: string;
            type: string;
        }) => item.statistic === value && item.type === type)
        findIemToChange.collect = !findIemToChange.collect
        setSqlExtendedOptionsList(list)
    }

    const updateExtendedStatistic = async() => {
        let url = `/sql/statistic/type`;
        try {
            const result = await api.post(url, sqlExtendedOptionsList)
            if (result && result.status === 200) {
                returnFromForm();
            }
        } catch (error: any) {
            console.error('Failed to update SQL statistics settings', error);
            const errorMessage = error.response?.data?.message || error.message || error.toString();
            showError('Failed to update SQL statistics settings', errorMessage);
        }
    }

    const filteredList = useMemo(() =>
        sqlExtendedOptionsList.filter((metric: any) =>
            (metric.statistic || '').toLowerCase().includes(detailFilter.toLowerCase())
        ), [sqlExtendedOptionsList, detailFilter])

    const renderedList = useMemo(() => {
        return filteredList?.map((metric: any[any], i) =>
            <div key={i} className='text-nowrap'>
                <input className="form-check-input" type="checkbox" id={`option_${i}`}
                       checked={metric.collect}
                    // Temp Fix
                       disabled={metric.statistic === 'executions' || metric.statistic === 'duration'}
                       onChange={() => updateSqlExtendedOptionsList(metric.statistic, metric.type)}
                />
                <label htmlFor={`option_${i}`}>{metric.statistic}</label>
            </div>)

    }, [filteredList])

    const checkUncheckAll = (checkState: boolean) => {
        // Only toggle the metrics currently visible under the active filter.
        const visible = new Set(filteredList.map((m: any) => `${m.type}::${m.statistic}`))
        const list = JSON.parse(JSON.stringify(sqlExtendedOptionsList))
        list.forEach((item: { collect: boolean, statistic: string, type: string }) => {
            const defaultChecked = item.statistic === 'executions' || item.statistic === 'duration'
            if (!defaultChecked && visible.has(`${item.type}::${item.statistic}`)) {
                item.collect = checkState
            }
        })
        setSqlExtendedOptionsList(list)
    }


    return (
        <div className="col h-100">
            <div className="card">
                <div className="card-header">
                    <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                    Update SQL Statistics

                    <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                       data-bs-target="#collapseDetails" aria-expanded="false" aria-controls="collapseDetails"/>
                </div>
                <div className={'form'}>
                    <div id="collapseDetails" className="card-body collapse show">
                        <div className="row row-cols-1 row-cols-md-2 table-search">
                            <div className="col col-md-10"/>
                            <div className="col col-md-2">
                                <SearchInput
                                    value={detailFilter}
                                    onChange={(e) => setDetailFilter(e.target.value)}
                                    onClear={() => setDetailFilter('')}
                                    autoFocus
                                />
                            </div>
                        </div>
                        <div className='select-all'>
                            <span onClick={() => checkUncheckAll(true)}>Select All</span><label
                            className='separator'>|</label><span
                            onClick={() => checkUncheckAll(false)}>Deselect All</span>
                        </div>
                        <div className='option-list'>
                            {renderedList}
                        </div>
                        {/* Form Actions */}
                        <div className="col-12 actions with-text">
                            <div/>
                            <span>When updates are complete, please restart one sensor of this technology type to ensure changes take effect</span>
                            <div>
                                <button onClick={returnFromForm} className="btn btn-secondary"><i
                                        className="fal fa-times-circle fa-fw fa-sm"/><span>Cancel</span></button>
                                <button onClick={() => updateExtendedStatistic()} type='submit'
                                        className='btn btn-success'>
                                    <i className='fal fa-save fa-sm'/><span>Update</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <NoData
                        error={null}
                        loading={loading === DATA_LOADING}
                        length={sqlExtendedOptionsList.length}
                />
            </div>
        </div>
    )
}

export default Details;
